/* eslint-disable import/namespace -- we are importing the custom panels which is not something eslint likes */

/*  React  */
import React from 'react';

import { type CustomPanel as CustomPanelType } from '../types';
import { Panel } from './Panel';
import * as CustomPanels from './custom';

/**
 * Renders a custom panel.
 *
 * @param panel - The panel to render.
 * @returns The rendered panel.
 */
export const CustomPanel = ({ panel }: { panel: CustomPanelType }) => {
    const {
        meta: { component }
    } = panel;

    if (!component || !(component in CustomPanels)) {
        throw new Error(`Component ${component} not found`);
    }

    const Component = CustomPanels[component as keyof typeof CustomPanels];
    const ComponentSkeleton =
        CustomPanels[`${component}Skeleton` as keyof typeof CustomPanels];

    return (
        <Panel panel={panel} skeleton={<ComponentSkeleton />}>
            <Component />
        </Panel>
    );
};
